export default [{
    path: 'accountCenter',
    redirect: '/accountCenter/index',
    children: [{
        path: '/accountCenter/index',
        meta: {
            title: "证书/账户状态",
            name: 'index',
            keepAlive: true
        },
        components: {
            mains: () => import('../views/accountCenter/index.vue')
        }
    } ]
}]